import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import React, { Component } from 'react'
import OrganizationsTable from './OrganizationTable'
import { connect } from 'react-redux'
import {
    deleteOmnitecOrganization,
    postOmnitecOrganization,
    updateOmnitecOrganization,
    fetchOmnitecOrganizations
} from '../../../../../api/omnitecApi/omnitecOrganizations'
import {
    selectOrganizations,
    selectOrganizationsFetching
} from '../../../../../selectors/omnitecSelectors/omnitecOrganizations'
import { selectEasymsOrganizationsKV } from '../../../../../selectors/easymsOrganizationSelector'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class OrganizationTab extends Component {
    state = {
        ourId: '',
        username: '',
        password: '',
        active: false
    }

    componentDidMount() {
        const params = { size: 300 }
        this.props.fetchOmnitecOrganizations(params)
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleCheck = name => event => {
        this.setState({ [name]: event.target.checked })
    }

    handleDelete = ourId => {
        this.props.deleteOmnitecOrganization(ourId)
    }

    handleUpdate = data => {
        this.props.updateOmnitecOrganization(data)
    }

    handleClick = () => {
        const { ourId, username, password, active } = this.state
        this.props.postOmnitecOrganization({
            ourId,
            username: username.trim(),
            password: password.trim(),
            active
        })
        this.setState({
            ourId: '',
            username: '',
            password: '',
            active: false
        })
    }

    render() {
        const { ourId, username, password, active } = this.state
        const { easymsOrganizationsKV, classes, organizations, fetching } = this.props

        const valid = ourId && username.trim() && password.trim()

        return (
            <div>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Организация EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsOrganizationsKV
                            .filter(option => !organizations.map(item => item.ourId).includes(option.value)) // remove organizations whitch have a mapping from dropdown
                            .map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                    </TextField>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-username">Имя пользователя</InputLabel>
                        <Input id="org-remote-username" name="username" value={username} onChange={this.handleChange} />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-password">Пароль</InputLabel>
                        <Input id="org-remote-password" name="password" value={password} onChange={this.handleChange} />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox checked={active} onChange={this.handleCheck('active')} value="active" />}
                        label="Активна"
                    />
                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>
                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <OrganizationsTable
                        easymsOrganizationsKV={easymsOrganizationsKV}
                        organizations={organizations}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        organizations: selectOrganizations(state),
        fetching: selectOrganizationsFetching(state),
        easymsOrganizationsKV: selectEasymsOrganizationsKV(state)
    }),
    { fetchOmnitecOrganizations, postOmnitecOrganization, updateOmnitecOrganization, deleteOmnitecOrganization }
)(withStyles(styles)(OrganizationTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/OrganizationTab/OrganizationTab.js